import { render, staticRenderFns } from "./AlertItemList.vue?vue&type=template&id=bac912a4&scoped=true&"
import script from "./AlertItemList.vue?vue&type=script&lang=js&"
export * from "./AlertItemList.vue?vue&type=script&lang=js&"
import style0 from "./AlertItemList.vue?vue&type=style&index=0&id=bac912a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac912a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bac912a4', component.options)
    } else {
      api.reload('bac912a4', component.options)
    }
    module.hot.accept("./AlertItemList.vue?vue&type=template&id=bac912a4&scoped=true&", function () {
      api.rerender('bac912a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/AlertItemList.vue"
export default component.exports